// src/App.jsx - UPDATED
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Mentors from './pages/Mentors';
import Workshops from './pages/Workshops';
import Collaborations from './pages/Collaborations';
import Community from './pages/Community';
import About from './pages/About';
import Contact from './pages/Contact';
import Team from './pages/Team'; // ✅ Add Team page

// Remove Internships temporarily or create placeholder
const Internships = () => (
  <div className="min-h-screen bg-gray-900 text-white py-20 text-center">
    <h1 className="text-4xl font-bold mb-4">Opportunities Coming Soon</h1>
    <p className="text-gray-300">Stay tuned for verified internship opportunities</p>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="mentors" element={<Mentors />} />
          <Route path="workshops" element={<Workshops />} />
          <Route path="collaborations" element={<Collaborations />} />
          <Route path="internships" element={<Internships />} />
          <Route path="community" element={<Community />} />
          <Route path="team" element={<Team />} /> {/* ✅ Add Team route */}
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;